interface HeroHeaderProps {
  eyebrow: string;
  name: string;
  subtitle?: string | null;
  dateRange: string | null;
}

export default function HeroHeader({ eyebrow, name, subtitle, dateRange }: HeroHeaderProps) {
  const now = new Date();
  const generated = new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(now);

  return (
    <div className="audience-hero">
      <p className="audience-hero__eyebrow">{eyebrow}</p>
      <h1 className="audience-hero__name">{name}</h1>
      {subtitle && <p className="audience-hero__subtitle">{subtitle}</p>}
      <div className="audience-hero__meta">
        {dateRange && <span>{dateRange}</span>}
        <span className="audience-hero__generated">Generated {generated}</span>
      </div>
    </div>
  );
}
